<template>
  <li :class="['card-meta-list-item', `card-meta-list-item--${orientation}`]">
    <span class="card-meta-list-item__label">{{ label }}</span>

    <span class="card-meta-list-item__value">
      <slot />
    </span>
  </li>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CardMetaListItem',

  props: {
    label: {
      type: String,
      required: true,
    },

    orientation: {
      type: String,
      default: 'horizontal',
    },
  },
});
</script>

<style lang="scss">
@use 'settings/colors';
.card-meta-list-item {
  grid-auto-flow: column;
  grid-gap: 8px;
  align-items: center;
}

.card-meta-list-item__label {
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.4px;
  color: colors.$color-text-grey;
  text-transform: uppercase;
  padding-top: 2px;
  display: block;
  white-space: nowrap;
}

.card-meta-list-item__value {
  font-size: 14px;
  color: #000;
  display: block;
  white-space: nowrap;
}

.card-meta-list-item--horizontal {
  display: grid;
  line-height: 2;
}

.card-meta-list-item--vertical {
  display: block;
  text-align: right;
}
</style>
